import { useTranslation } from '@presentation/utils';
import type { FC } from 'react';
import { useState } from 'react';
import { TbCheck, TbClipboard } from 'react-icons/tb';
import { Button } from '../Button';
import { Card } from '../Card';
import { Modal } from '../Modal';
import { ModalCloseButton } from '../ModalCloseButton';
import { ModalTitle } from '../ModalTitle';
import { Section } from '../Section';
import { BUTTON_ICON } from './constants';
import * as Styled from './styled';
import type { SocialShareButtonType, SocialShareModalProps } from './types';

export const SocialShareModal: FC<SocialShareModalProps> = (props) => {
  const { urls, modal } = props;
  const { translate } = useTranslation();
  const [copied, setCopied] = useState(false);

  return (
    <Modal {...modal}>
      <Card size="small" isModal>
        <ModalTitle>{translate('glossary.share')}</ModalTitle>
        <ModalCloseButton modal={modal} />

        <Section>
          <Styled.Container>
            {Object.keys(urls ?? {}).map((key) => (
              <Styled.Button
                key={key}
                type={key as SocialShareButtonType}
                href={urls?.[key as SocialShareButtonType]}
                target="_blank"
              >
                {BUTTON_ICON[key as SocialShareButtonType]}
                <div>{translate(`enum.socialShare.${key}`)}</div>
              </Styled.Button>
            ))}
          </Styled.Container>

          <Styled.CopyContainer>
            <Button
              iconLeft={!copied ? <TbClipboard /> : <TbCheck />}
              shrink
              onClick={(e) => {
                e.preventDefault();
                navigator.clipboard.writeText(window.location.href);
                setCopied(true);
                setTimeout(() => setCopied(false), 2000);
              }}
            >
              {!copied ? translate('common.buttons.copy') : translate('common.buttons.copied')}
            </Button>
          </Styled.CopyContainer>
        </Section>
      </Card>
    </Modal>
  );
};
